<template>
  <div
    class="scenarios"
    :style="{
      background: `url(${transformImage(
        isChinese()
          ? getFeUrl('/youyan-platform/png/template-common-bg.png')
          : getFeUrl('/rendora/template-common-bg.jpeg')
      )})`,
      backgroundSize: 'cover',
    }"
  >
    <h4>{{ $t('ta-men-zhe-yang-zuo-shi-pin') }}</h4>
    <a-carousel
      class="scenarios-list mx-auto"
      :autoplay="true"
      :autoplaySpeed="3000"
    >
      <div
        v-for="(item, idx) in displayScenarios || []"
        :key="idx"
        class="scenario-group"
      >
        <nuxt-link
          v-for="scenario in item"
          :key="scenario.name"
          class="scenario-item"
          :style="{
            backgroundImage: `url(${transformImage(
              getScenarioImage(scenario)
            )})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }"
          :to="`/scenarios/${scenario.outer_id}.html`"
          aria-label="go scenario detail page"
          @click="
            () => {
              trackEvent(TRACK_EVENT.CLICK_INDUSTRY_APP_CARD, {
                industry: scenario.name,
                position: '首页',
              })
            }
          "
        >
          {{ scenario.name }}
        </nuxt-link>
      </div>
    </a-carousel>
  </div>
</template>

<script lang="ts" setup>
import type { ScenariosTag, Tag } from '~/api/interface'

const scenariosTag = useScenariosTags()

const displayScenarios = computed(() => {
  const len = scenariosTag.value?.length || 0
  const end = len > 6 ? Math.floor((len || 0) / 6) : 1
  const collection = []
  for (let i = 0; i < end; i++) {
    collection.push((scenariosTag.value || [])?.slice(i * 6, (i + 1) * 6))
  }
  return collection
})

const getScenarioImage = (item: ScenariosTag) => {
  return item.index_background_cover_url
}
</script>
<style lang="scss" scoped>
:deep(iconpark-icon) {
  opacity: 0.8;
  &:hover {
    opacity: 1;
  }
}
:deep(.ant-carousel .slick-dots-bottom) {
  bottom: rem(-20);
}
:deep(.ant-carousel .slick-dots button) {
  display: block;
  width: rem(8);
  height: rem(8);
  border-radius: 50%;
  background-color: var(--text-1);
  opacity: 0.2;
}
:deep(.ant-carousel .slick-dots li.slick-active button) {
  background-color: var(--text-1);
  opacity: 0.6;
}
:deep(.ant-carousel .slick-dots li) {
  display: block;
  width: rem(8);
  height: rem(8);
  border-radius: 50%;
}
:deep(.slick-slide) {
  text-align: center;
  overflow: hidden;
}
:deep(.slick-slide h3) {
  color: #fff;
}

.scenarios-list {
  width: rem(420);
  .scenario-item {
    display: flex;
    align-items: center;
    font-weight: 600;
    justify-content: center;
    font-size: rem(12);
    color: #fff;
    width: rem(132);
    height: rem(38);
    line-height: 16px;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: rem(8);
    background-color: #53289a;
    position: relative;
    overflow: hidden;
    &:hover {
      &::after {
        // mask
        content: '';
        display: block;
        position: absolute;
        pointer-events: none;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
}

.scenarios {
  display: flex;
  flex-direction: column;
  width: rem(472);
  height: rem(189);
  border-radius: rem(12);
  background-size: cover;

  h4 {
    font-size: rem(14);
    font-weight: 600;
    text-align: center;
    margin: rem(28) auto rem(18);
    color: var(--text-1);
  }
}

.scenario-group {
  display: grid !important;
  width: rem(472);
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: rem(12);
}
</style>
